import React from 'react';
import styled from 'styled-components';
import { animated, config, useSpring } from 'react-spring';
// import Brand from './Brand';
// import { Link } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { HashLink as Link } from 'react-router-hash-link';
import BurgerMenu from './BurgerMenu';
import CollapseMenu from './CollapseMenu';
import { scrollToTop } from '../../ScrollToTop';

const ResponsiveNavBar = ({ handleNavbar, navbarState }) => {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const barAnimation = useSpring({
    from: { transform: 'translate3d(0, -100px, 0)' },
    transform: 'translate3d(0, 0, 0)',
  });

  const linkAnimation = useSpring({
    from: { transform: 'translate3d(0, 30px, 0)', opacity: 0 },
    to: { transform: 'translate3d(0, 0, 0)', opacity: 1 },
    delay: 800,
    config: config.wobbly,
  });

  return (
    <>
      {isMobile ? (
        <NavBar style={barAnimation}>
          <FlexContainer>
            <TitleMobile to="/" onClick={scrollToTop(true)} style={{ fontSize: '20px' }}>Shapira Bros</TitleMobile>
            <BurgerWrapper>
              <BurgerMenu
                navbarState={navbarState}
                handleNavbar={handleNavbar}
              />
            </BurgerWrapper>
          </FlexContainer>
          <CollapseMenu
            navbarState={navbarState}
            handleNavbar={handleNavbar}
          />
        </NavBar>
      )
        : (
          <NavBar style={barAnimation}>
            <FlexContainer>
              <NavLinks style={linkAnimation}>
                <Link to="/" onClick={scrollToTop(true)} style={{ fontSize: '20px' }}>Shapira Bros</Link>
              </NavLinks>
              <NavLinks style={linkAnimation}>
                <Link smooth to="/#services">Services</Link>
                <Link smooth to="/#work">Work</Link>
                <Link smooth to="/#clients">Clients</Link>
                <Link smooth to="/#contact">Contact</Link>
                <Link to="/about" onClick={scrollToTop(false)}>About</Link>
              </NavLinks>
            </FlexContainer>
          </NavBar>
        )}
    </>
  );
};

export default ResponsiveNavBar;

const NavBar = styled(animated.nav)`
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  background: linear-gradient(to bottom right, #7a7a7a, #383838);
  font-size: 14px;
  z-index: 200;
  
  @media (max-width: 768px) {
      background: #2d3436;
    }
`;

const FlexContainer = styled.div`
  max-width: 1400px;
  display: flex;
  align-items: center;
  margin: auto;
  padding: 0 20px;;
  justify-content: space-between;
  height: 50px;
  z-index: 200
`;

const NavLinks = styled(animated.ul)`
  justify-self: end;
  list-style-type: none;
  margin: auto 0;

  & a {
    color: #dfe6e9;
    text-transform: uppercase;
    font-weight: 600;
    border-bottom: 1px solid transparent;
    margin: 0 15px;
    transition: all 300ms linear 0s;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      color: #fdcb6e;
      border-bottom: 1px solid #fdcb6e;
    }
  }
`;

const BurgerWrapper = styled.div`
  margin: auto 0;
  user-select: none;
`;

const TitleMobile = styled.span`
    color: #dfe6e9;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 20px;
    user-select: none;
    cursor: pointer;
`;
